import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'img']

  open(event) {
    this.imgTarget.src = event.currentTarget.dataset.src
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
